import logo from './images/NRWE_LOGO.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
      </header>
     
    </div>
  );
}

export default App;
